import { defineStore } from 'pinia'
import Ability from '@/types/Ability'
import { createMongoAbility, ExtractSubjectType, MongoQuery, SubjectRawRule } from '@casl/ability'
import { Actions, AppAbility, Resources } from '@/plugins/permissions/typing'
import { ref, watchEffect } from 'vue'
import { ability } from '@/plugins/permissions'

type AppAbilityRule = SubjectRawRule<Actions, ExtractSubjectType<Resources>, MongoQuery>

export const usePermissionStore = defineStore(
  'permission',
  () => {
    const abilities = ref<Ability[]>([])

    const applied = ref<AppAbilityRule[]>([])

    function update(value: Ability[]) {
      abilities.value = value
    }

    function clear() {
      abilities.value = []
    }

    // Every time the store abilities are updated (this includes on hydration)
    // the watcher will trigger to update the rules inside CASL plugin
    watchEffect(
      () => {
        if (abilities.value === undefined) return

        const defined = createMongoAbility<AppAbility>(
          abilities.value.map(
            (v) => {
              // Alias for "all abilities"
              if (v.name === '*') {
                return { action: 'manage' as Actions, subject: 'all' as Resources, inverted: v.forbidden }
              }

              // Abilities formatted as <action>.<subject>
              const [action, subject] = v.name.split(/(?<=^[^.]+)\./)
              return { action: action as Actions, subject: subject as Resources, inverted: v.forbidden }
            },
          ),
        )

        applied.value = defined.rules
        ability.update(applied.value)
      },
    )

    return { abilities, applied, update, clear }
  },
  {
    persist: true,
  },
)
